module.exports = __webpack_public_path__ + "static/media/6.163c2a0b.svg";